import { render, staticRenderFns } from "./FiBuSuSaList.vue?vue&type=template&id=5a7f2c71&"
import script from "./FiBuSuSaList.vue?vue&type=script&lang=js&"
export * from "./FiBuSuSaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports